import { render, staticRenderFns } from "./PermissionManage.vue?vue&type=template&id=b2c3620e&"
import script from "./PermissionManage.vue?vue&type=script&lang=js&"
export * from "./PermissionManage.vue?vue&type=script&lang=js&"
import style0 from "./PermissionManage.vue?vue&type=style&index=0&id=b2c3620e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports